import '../js/jquery-zoom/jquery.zoom.js'

const product = {};

(function (productApp) {
    

    $(document).ready(function () {

        /* ==========================================================================
          jQuery Zoom image
           ========================================================================== */

        if (window.matchMedia("(min-width:  769px)").matches) {
            if (document.querySelector(".image-zoom")) {
                $('.image-zoom')
                    .wrap('<span style="display:inline-block"></span>')
                    .css('display', 'block')
                    .parent()
                    .zoom();
            }
        }
    });

})(product);
